<template>
  <PlatformChampionPicker />
  <OptionPicker />
  <BadgesPicker />
</template>
<script setup>
import PlatformChampionPicker from "./pickers/ApexPlatformChampionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import BadgesPicker from "./pickers/BadgesPicker.vue";
import { onMounted } from "vue";
const checkoutStore = useCheckoutStore();
const { setDetails, setPlatform, setGameAndPack, setOneHero, setBadges } =
  checkoutStore;
const { currentGameSlug } = useGameComposable();

const gameStore = useGameStore();
const { getGame, getGamePack, getGameRanks, apiGetGameHeroes } = gameStore;

const handleDetails = () => {
  checkoutStore.clearCheckout("test");
  setPlatform({
    platform: 1,
  });
  setBadges({
    badgeId: 1,
  });
  apiGetGameHeroes({
    gameSlug: currentGameSlug,
  }).then(() => {
    setOneHero({
      championId: gameStore.getGameHeroes[0].id,
    });
  });

  setGameAndPack({
    game: getGame.id,
    pack: getGamePack.id,
    fullGame: getGame,
    fullPack: getGamePack,
  });
};

handleDetails();
onMounted(() => {
  checkoutStore.setCalculating();
});
</script>
